import React from 'react'
import Review_client from './Sections/Review_client'


export const Review = () => {
    return (
      <>
        <Review_client/>
      </>
    )
}